module.exports = "https://mrkt-web.scdn.co/artists-spotify-com/_next/static/images/footer-ios-a77e2676a3ffba2c521ce743a6d82eea.svg";